import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { VariantColor } from '@repo/toolkit/colors'
import Badge from '@repo/ui/badge'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'
import { useTranslation } from 'react-i18next'

import {
  StaffQualificationEnum,
  staffQualificationEnumMapping
} from '../../../../lib/types/enums/staff/staff-qualifications.enum'

type Props = {
  title: string
  variant: VariantColor
  total: number
  mapping: Partial<Record<StaffQualificationEnum, number>>[]
}

const StaffQualificationStatisticsCard = ({ title, variant, total, mapping }: Props) => {
  const { t } = useTranslation()

  return (
    <InnerBox className="rounded-lg p-3 flex flex-col gap-2 w-full">
      <Badge variant={variant} className="border-none" text={title + total.toString()} />
      {/* Iterate over the mapping and display each qualification and its corresponding number */}
      {mapping.map((record, index) => (
        <div key={index} className="flex justify-between">
          {Object.entries(record).map(([qualification, number]) => (
            <div key={qualification} className="flex items-center gap-2">
              <Typography variant="label-semibold" className={tailwindColors.grey.DEFAULT}>
                {t(staffQualificationEnumMapping[qualification as StaffQualificationEnum].label)}
              </Typography>
              <Badge text={number.toString()} />
            </div>
          ))}
        </div>
      ))}
    </InnerBox>
  )
}

export default StaffQualificationStatisticsCard
